import {logger} from '../../../utils/logging/logger'

/**
 * Posts a message to the parent window if the current page is embedded in an iframe.
 * This is useful for communicating navigation events to the parent frame.
 * @param url - The URL that would be navigated to
 * @param options - Optional configuration
 * @param options.messageType - Custom message type (default: 'redirect')
 * @param options.parentOrigin - The origin of the parent window (default: '*')
 */
export const postMessageToParent = (
  url: string,
  options?: {
    messageType?: 'redirect' | 'navigate'
    parentOrigin?: string
  }
): void => {
  if (typeof window === 'undefined' || !window.parent) {
    return
  }

  try {
    const absoluteUrl = new URL(url, window.location.origin).href

    const message = {
      type: options?.messageType || 'redirect',
      redirect_target: absoluteUrl
    }

    window.parent.postMessage(message, options?.parentOrigin || '*')
  } catch (error) {
    // Silently fail if we can't post message (e.g., cross-origin restrictions)
    // This is expected behavior in some embedded scenarios
    if (process.env.NODE_ENV === 'development') {
      logger.warn('Failed to post message to parent:', error)
    }
  }
}
